export const GET_RESOURCE_LIST = 'GET_RESOURCE_LIST';
export const CURRENT_PAGE = 'CURRENT_PAGE';
export const HAS_MORE = 'HAS_MORE';
export const RESET_RESOURCE_STATE = 'RESET_RESOURCE_STATE';
